import MileageSettingsAddRequest, {
  MileageSettingsAddRequestMileageNumberCreationModel,
} from "../../../../api/raily/mileage/settings/add/mileage-settings-add.request";
import MileageNumberCreationModel from "../../../../types/mileage-number-creation-model";
import MileageSettingsAddParams from "./mileage-settings-add-params";

const createCreationModel = (
  model: MileageNumberCreationModel | undefined,
): MileageSettingsAddRequestMileageNumberCreationModel | undefined => {
  switch (model) {
    case MileageNumberCreationModel.AUTO:
      return MileageSettingsAddRequestMileageNumberCreationModel.AUTO;
    case MileageNumberCreationModel.DICT:
      return MileageSettingsAddRequestMileageNumberCreationModel.DICT;
    case MileageNumberCreationModel.MANUAL:
      return MileageSettingsAddRequestMileageNumberCreationModel.MANUAL;
    default:
      return undefined;
  }
};

const create = (
  params: MileageSettingsAddParams,
): MileageSettingsAddRequest => {
  return {
    companyUuid: params.companyUuid,
    isCardNumberRequired: params.isCardNumberRequired,
    isMileageNumberRequired: params.isMileageNumberRequired,
    mileageNumberCreationType: createCreationModel(
      params.mileageNumberCreationModel,
    ),
  };
};

const mileageSettingsAddParamsFactory = {
  create,
};

export default mileageSettingsAddParamsFactory;
